function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  color: #ff3b30;\n  margin: 0.25rem 0 0 0;\n  font-style: italic;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React from "react";
import { Formik, Form } from "formik";
import { object, string } from "yup";
import { withContext } from "../wr-context";
import { Row, SpacedCol } from "../grid";
import { FormikInput } from "../input";
import { FormikButton } from "../button";
import Card from "../card";
import styled from "styled-components";
var SimplePass = function() {
    var ref = _slicedToArray(React.useState(false), 2), error = ref[0], setError = ref[1];
    var handleSubmit = function(values) {
        setError(false);
        if (values.password === process.env.REACT_APP_ACCESS_PASS) {
            localStorage.setItem("isLogged", "true");
            location.reload();
        } else {
            setError(true);
        }
    };
    var validationSchema = object({
        password: string().min(1).max(128).required()
    });
    var initialValues = {
        password: ""
    };
    var renderCredentials = function() {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(SpacedCol, {
            xs: 12
        }, /*#__PURE__*/ React.createElement(FormikInput, {
            name: "password",
            type: "password",
            label: "Password",
            placeholder: "",
            fullWidth: true
        }), error && /*#__PURE__*/ React.createElement(Error, null, "Incorrect password")), /*#__PURE__*/ React.createElement(SpacedCol, {
            xs: 12
        }, /*#__PURE__*/ React.createElement(FormikButton, {
            alwaysActive: true,
            primary: true,
            type: "submit"
        }, "Log In")));
    };
    return /*#__PURE__*/ React.createElement(Formik, {
        onSubmit: handleSubmit,
        initialValues: initialValues,
        validationSchema: validationSchema
    }, /*#__PURE__*/ React.createElement(Form, {
        noValidate: true,
        onChange: function() {
            return setError(false);
        }
    }, /*#__PURE__*/ React.createElement(Card, {
        md: true
    }, function(param) {
        var Body = param.Body;
        return /*#__PURE__*/ React.createElement(Body, null, /*#__PURE__*/ React.createElement(Row, null, renderCredentials()));
    })));
};
var Error = styled.div(_templateObject());
export default withContext(SimplePass);
